import React from "react";
import { Grid } from "@mui/material";
import { getAssets } from "@unisearch/helpers";
import styles from "./uni_overview_accomodation.module.scss";
import { ReactSVG } from "react-svg";
import { htmlParse } from "@unisearch/helpers";

export const UniOverviewAccomodation = ({
  universityProfileData,
  overviewData,
}) => {
  return (
    <>
      {overviewData?.onCampusAccommodation && (
        <section className={styles.section_accomodation}>
          <div className="container">
            <div className={styles.title_wrapper}>
              <h2>Accommodation</h2>
              <p className={styles.short_description}>
                Get a headstart on finding the right student housing on- or
                off-campus for <br />{" "}
                <span style={{ fontWeight: 500 }}>
                  {universityProfileData?.universityName}
                </span>{" "}
                through our handy list of options below!
              </p>
            </div>

            <Grid container spacing={6}>
              <Grid item xs={12} sm={12} md={7}>
                <div className={styles.acc_heading}>
                  On campus accommodation :<br />
                  <span>(Available)</span>
                </div>
                <div className={styles.acc_desc_title}>Description</div>
                <div className={`${styles.acc_desc} from_texteditor_wrapper`}>
                  {overviewData?.onCampusAccommodation
                    ? htmlParse(overviewData.onCampusAccommodation)
                    : ""}
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={5}>
                <div className={styles.image_wrapper}>
                  <ReactSVG
                    className={styles.image_ornament}
                    src={getAssets(
                      "assets/images/uni-profile/image_ornament.svg"
                    )}
                  />
                  <img
                    className={styles.image_shadow}
                    src={getAssets(
                      "assets/images/uni-profile/image_shadow2.png"
                    )}
                    alt="Shadow"
                  />
                  <img
                    src={getAssets(
                      "assets/images/uni-profile/Accommodation.jpg"
                    )}
                    alt="Accommodation"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </section>
      )}
    </>
  );
};

export default UniOverviewAccomodation;
